var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnquiryChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1595_6618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58366 2.875H13.417C15.4503 2.875 17.4004 3.68274 18.8381 5.12051C20.2759 6.55829 21.0837 8.50834 21.0837 10.5417C21.0837 12.575 20.2759 14.525 18.8381 15.9628C17.4004 17.4006 15.4503 18.2083 13.417 18.2083V21.5625C8.62533 19.6458 1.91699 16.7708 1.91699 10.5417C1.91699 8.50834 2.72473 6.55829 4.16251 5.12051C5.60029 3.68274 7.55033 2.875 9.58366 2.875ZM11.5003 16.2917H13.417C14.1721 16.2917 14.9198 16.1429 15.6174 15.854C16.315 15.565 16.9489 15.1415 17.4829 14.6075C18.0168 14.0736 18.4403 13.4397 18.7293 12.7421C19.0183 12.0445 19.167 11.2968 19.167 10.5417C19.167 9.78657 19.0183 9.03886 18.7293 8.34124C18.4403 7.64361 18.0168 7.00974 17.4829 6.4758C16.9489 5.94187 16.315 5.51832 15.6174 5.22936C14.9198 4.94039 14.1721 4.79167 13.417 4.79167H9.58366C8.05866 4.79167 6.59613 5.39747 5.5178 6.4758C4.43946 7.55414 3.83366 9.01667 3.83366 10.5417C3.83366 14.0012 6.19308 16.2591 11.5003 18.6683V16.2917Z",
    fill: "#FF395D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.70801,
    y: 9.5835,
    width: 1.91667,
    height: 1.91667,
    fill: "#FF395D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.375,
    y: 9.5835,
    width: 1.91667,
    height: 1.91667,
    fill: "#FF395D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.542,
    y: 9.5835,
    width: 1.91667,
    height: 1.91667,
    fill: "#FF395D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1595_6618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryChat);
export default __webpack_public_path__ + "static/media/enquiry-chat.0963ce0447b2f3c4ad53e54bfd9c8a24.svg";
export { ForwardRef as ReactComponent };